import React, { Component } from 'react';
import styles from './FloatingActionButtonsStyles';
import PropTypes from 'prop-types';
import Radium from 'radium';
import { getElementStageLayout } from '../MouseCatcherUtils';
import { getElementDefinitionProps, getEditModeTitle } from 'crazyEditor/core/elements/utils/elementDefinitionUtils';
import { connect } from 'react-redux';
import { getSelectedElementsWithDragPosition } from 'crazyEditor/redux/modules/element/elementSelectors';
import { editDesktopElement, isEditable } from 'crazyEditor/core/elements/utils/elementAddUpdateUtils';
import RaisedButton from 'material-ui/RaisedButton';
import { clearEditingTextElementId } from 'crazyEditor/redux/modules/stage/stage';
import { elementTypes } from 'crazyEditor/components/Elements/index';
import shallowEqual from 'fbjs/lib/shallowEqual';
import {isMultiSelect} from 'crazyEditor/redux/modules/element/elementSelectors';

const supportedElements = [
  elementTypes.ImageElement,
  elementTypes.IconElement,
  elementTypes.TabsElement,
  elementTypes.TitleElement,
  elementTypes.RichTextElement,
  elementTypes.VideoElement,
  elementTypes.HtmlElement,
  elementTypes.GalleryElement,
  elementTypes.CrossSellGalleryElement,
];

@connect(
  state => ({
    selectedElements: getSelectedElementsWithDragPosition(state),
    isMultiSelect: isMultiSelect(state),
    editingElementId: state.stage.editingElementId
  }),
  {clearEditingTextElementId}
)
@Radium
export default class FloatingActionButtons extends Component {
  constructor(props) {
    super(props);

    this.onClick = this.onClick.bind(this);
  }

  shouldComponentUpdate(nextProps, nextState) {
    return !shallowEqual(this.props, nextProps) || !shallowEqual(this.state, nextState);
  }

  onClick() {
    const { editingElementId, clearEditingTextElementId } = this.props;
    if (!editingElementId && this.selectedElement) {
      editDesktopElement(this.selectedElement);
    } else {
      clearEditingTextElementId();
    }
  }

  getStyles(selectedElement, editingElementId) {
    return [
      getElementStageLayout(selectedElement),
      styles.actionButtonWrapper,
      editingElementId && getElementDefinitionProps(selectedElement).ckfinderEnabled && styles.actionButtonWrapperRichText
    ];
  }

  render() {
    const { selectedElements, editingElementId, isMultiSelect } = this.props;
    const selectedElement = selectedElements[0];
    if (isMultiSelect || (selectedElement && supportedElements.indexOf(selectedElement.type) === -1 || !isEditable(selectedElement))) {
      return null;
    }

    return (
      <div style={this.getStyles(selectedElement, editingElementId)}>
        <RaisedButton label={editingElementId ? 'DONE' : getEditModeTitle(selectedElement)}
                      style={styles.actionButton}
                      primary
                      onMouseDown={(e) => {
                        e.stopPropagation();
                        // button may re-render before click is completed, so we keep the behavior from mouse down.
                        this.selectedElement = editingElementId ? null : selectedElement;
                      }}
                      onClick={() => {this.onClick();}}/>
      </div>
    );
  }
}